import { CONTAINER_SPACING_PX, type SpacingToken } from '../lib/spacing';
import { StructuredContentRenderer } from '../renderer';
import type { NodeProps, StructuredContent } from '../types';

export type StickyContainerProps = NodeProps<{
  children: StructuredContent | StructuredContent[];
  spacing?: SpacingToken;
}>;

/**
 * Sticks to the top of its column. Only `stickTo: top` occurs in WP content.
 * Source: NerdWallet/structured-content shared-core/src/components/sticky-container/index.tsx.
 */
export function StickyContainer({ props }: StickyContainerProps) {
  return (
    // z-index 700: legacy sticky-container/index.tsx, keeps the rail above content cards.
    <div
      className="sticky z-[700]"
      style={{ top: CONTAINER_SPACING_PX[props.spacing ?? '0'] ?? 0 }}
    >
      <StructuredContentRenderer doc={props.children} />
    </div>
  );
}
